import { useEffect, useState } from "react";
import { useParams } from "react-router";
import {
  Wrapper,
  ContentWrapper,
  ImageCard,
  Image,
  CloseIcon,
} from "./ImageElements";
import unsplash from "../../unsplash";
import { GrClose } from "react-icons/gr";

const Modal = ({ isOpen, toggle }) => {
  const [image, setImage] = useState({});

  const params = useParams();

  useEffect(() => {
    unsplash
      .get(`/photos/${params.id}`)
      .then((res) => {
        setImage(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [params.id]);

  console.log(params.id);

  return (
    <>
      {isOpen ? (
        <Wrapper>
          <ContentWrapper>
            <CloseIcon onClick={toggle}>
              <GrClose />
            </CloseIcon>
            <ImageCard>
              <img
                src={image.urls && image.urls.regular}
                alt={image.alt_description}
              />
            </ImageCard>
          </ContentWrapper>
        </Wrapper>
      ) : null}
    </>
  );
};

export default Modal;
